<template>
<section>
  <v-btn @click="dialog=true">Add Site Map</v-btn>
  <v-layout style="margin: 12px;" row>
     <v-flex xs6 pa-2>
      <v-card>
        <v-card-text>
            <v-flex>
                  <v-flex>
                    <v-radio-group row v-model="Page_Name">
                        <v-radio label="Home Page" value="Home"></v-radio>
                        <v-radio label="Jobs Page" value="Jobs"></v-radio>
                        <v-radio label="Projects Page" value="Projects"></v-radio>
                        <v-radio label="Category / Course Page" value="Course_Category"></v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Title" v-model="Meta_Title"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Keywords" v-model="Meta_Keywords"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Description" v-model="Meta_Description"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Abstract" v-model="Meta_Abstract"></v-text-field>
                </v-flex>
                <v-flex>
                     <v-text-field label="Meta Author" v-model="Meta_Author"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Copyright" v-model="Meta_Copyright"></v-text-field>
                </v-flex>
                <v-flex>
                     <v-text-field label="Meta Distribution" v-model="Meta_Distribution"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Item Prop Name" v-model="Meta_Item_Prop_Name"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Item Prop Description" v-model="Meta_Item_Prop_Description"></v-text-field>
                </v-flex>
                <v-flex>
                     <v-text-field label="Meta Item Prop Image" v-model="Meta_Item_Prop_Image"></v-text-field>
                </v-flex>
                <v-flex>
                     <v-text-field label="Meta Property OG Type" v-model="Meta_Property_OG_Type"></v-text-field>
                </v-flex>
                <v-flex>
                     <v-text-field label="Meta Property OG URL" v-model="Meta_Property_OG_URL"></v-text-field>
                </v-flex>
                <v-flex>
                     <v-text-field label="Meta Property OG SiteName" v-model="Meta_Property_OG_SiteName"></v-text-field>
                </v-flex>
                <v-flex>
                        <v-text-field label="Meta Property OG Title" v-model="Meta_Property_OG_Title"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Property OG Description" v-model="Meta_Property_OG_Description"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Property OG Author" v-model="Meta_Property_OG_Author"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Property OG Image" v-model="Meta_Property_OG_Image"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Property Article Author" v-model="Meta_Property_Article_Author"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field label="Meta Property Article Publisher" v-model="Meta_Property_Article_Publisher"></v-text-field>
                </v-flex>
          </v-flex>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: right;">
            <v-btn color="primary" v-if="!UpdateDetails" @click="SubmitPageSEO">Add SEO Details</v-btn>
            <v-btn color="primary" v-else @click="SubmitPageSEO">Update SEO Details</v-btn>
            <v-btn @click="ClearForm">Clear SEO Details</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs6 pa-2>
      <v-data-table :headers="headers" 
                      :items="SEOList" 
                      hide-actions
                      disable-initial-sort
                      class="elevation-1">
            <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                    </th>
                </tr>
            </template>
            <template v-slot:items="props">
                <tr>
                    <td class="text-xs-center">{{ props.item.Page_Name }}</td>
                    <td class="text-xs-center">
                        <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                  <v-btn color="primary" icon class="btnAction" v-on="on" @click="OpenUpdateSEO(props.item)">
                                    <v-icon>edit</v-icon>
                                  </v-btn>
                              </template>
                              <span>Update</span>
                        </v-tooltip>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-flex>
    <app-sitemap :dialog='dialog' @close='CloseModel'></app-sitemap>
  </v-layout>
</section>
</template>
<script>
import { VueEditor } from "vue2-editor";
import appSitemap    from '../views/dialogs/Sitemap'

export default {
  components: {
    VueEditor,
    appSitemap
  },
  data() {
    return {

      dialog            : false,
      UpdateDetails     : false,
      Page_Name         : "",
      Meta_Title        : "",
      Meta_Keywords     : "",
      Meta_Description  : "",
      Meta_Abstract     : "",
      Meta_Author       : "",
      Meta_Copyright    : "",
      Meta_Distribution : "",
      Meta_Item_Prop_Name         : "",
      Meta_Item_Prop_Description  : "",
      Meta_Item_Prop_Image        : "",
      Meta_Property_OG_Type       : "",
      Meta_Property_OG_URL        : "",
      Meta_Property_OG_SiteName   : "",
      Meta_Property_OG_Title      : "",
      Meta_Property_OG_Description  : "",
      Meta_Property_OG_Author       : "",
      Meta_Property_OG_Image        : "",
      Meta_Property_Article_Author    : "",
      Meta_Property_Article_Publisher : "",
      SEOList          : [],
      headers          : [ { text: 'Page Name',value: 'Page_Name' },
                           { text: 'Actions' } ],
    }
  },
  methods: {
    CloseModel(){
      this.dialog = false
    },
    SubmitPageSEO() {

      let PageSEO = {};
      PageSEO["Page_Name"] = this.Page_Name;
      PageSEO["update"] = {};
      PageSEO['update']['Meta_Title']             = this.Meta_Title
      PageSEO["update"]["Meta_Keywords"]          = this.Meta_Keywords;
      PageSEO["update"]["Meta_Description"]       = this.Meta_Description;
      PageSEO["update"]["Meta_Abstract"]          = this.Meta_Abstract;
      PageSEO["update"]["Meta_Author"]            = this.Meta_Author;
      PageSEO["update"]["Meta_Copyright"]         = this.Meta_Copyright;
      PageSEO["update"]["Meta_Distribution"]      = this.Meta_Distribution;
      PageSEO["update"]["Meta_Item_Prop_Name"]        = this.Meta_Item_Prop_Name;
      PageSEO["update"]["Meta_Item_Prop_Description"] = this.Meta_Item_Prop_Description;
      PageSEO["update"]["Meta_Item_Prop_Image"]   = this.Meta_Item_Prop_Image;
      PageSEO["update"]["Meta_Property_OG_Type"]  = this.Meta_Property_OG_Type;
      PageSEO["update"]["Meta_Property_OG_URL"]   = this.Meta_Property_OG_URL;
      PageSEO["update"]["Meta_Property_OG_SiteName"] = this.Meta_Property_OG_SiteName;
      PageSEO["update"]["Meta_Property_OG_Title"]    = this.Meta_Property_OG_Title;
      PageSEO["update"]["Meta_Property_OG_Description"] = this.Meta_Property_OG_Description;
      PageSEO["update"]["Meta_Property_OG_Author"]      = this.Meta_Property_OG_Author;
      PageSEO["update"]["Meta_Property_OG_Image"]       = this.Meta_Property_OG_Image;
      PageSEO["update"]["Meta_Property_Article_Author"] = this.Meta_Property_Article_Author;
      PageSEO["update"]["Meta_Property_Article_Publisher"] = this.Meta_Property_Article_Publisher;
  
      this.$http.post(`${this.$store.getters.GetProductionUrl}/courseseo/addpageseo`,PageSEO)
                .then(response => {

                    let Index = this.SEOList.findIndex(x => x['_id'] == response['data']['response']['_id'] )
                    if(Index > -1){

                      this.SEOList.splice(Index, 1, response['data']['response'])

                    }else{

                      this.SEOList.push(response['data']['response'])

                    }
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: `Successfully Updated SEO`,Color: "green", Close: false });
                    this.ClearForm();
                })
                .catch(err => {

                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Failed To Add SEO", Color: "red", Close: false});
                });
    },
    ClearForm() {

      this.Page_Name      = ''
      this.Meta_Title     = ""
      this.Meta_Keywords  = "";
      this.Meta_Description = "";
      this.Meta_Abstract    = "";
      this.Meta_Author      = "";
      this.Meta_Copyright   = "";
      this.Meta_Distribution    = "";
      this.Meta_Item_Prop_Name  = "";
      this.Meta_Item_Prop_Description = "";
      this.Meta_Item_Prop_Image       = "";
      this.Meta_Property_OG_Type      = "";
      this.Meta_Property_OG_URL       = "";
      this.Meta_Property_OG_SiteName  = "";
      this.Meta_Property_OG_Title     = "";
      this.Meta_Property_OG_Description = "";
      this.Meta_Property_OG_Author      = "";
      this.Meta_Property_OG_Image       = "";
      this.Meta_Property_Article_Author = "";
      this.Meta_Property_Article_Publisher = "";
      this.UpdateDetails = false

    },
    OpenUpdateSEO(Item){

      this.Page_Name            = Item['Page_Name'];
      this.Meta_Title           = Item['Meta_Title']
      this.Meta_Keywords        = Item['Meta_Keywords'];
      this.Meta_Description     = Item['Meta_Description'];
      this.Meta_Abstract        = Item['Meta_Abstract'];
      this.Meta_Author          = Item['Meta_Author'];
      this.Meta_Copyright       = Item['Meta_Copyright'];
      this.Meta_Distribution    = Item['Meta_Distribution'];
      this.Meta_Item_Prop_Name  = Item['Meta_Item_Prop_Name'];
      this.Meta_Item_Prop_Description = Item['Meta_Item_Prop_Description'];
      this.Meta_Item_Prop_Image       = Item['Meta_Item_Prop_Image'];
      this.Meta_Property_OG_Type      = Item['Meta_Property_OG_Type'];
      this.Meta_Property_OG_URL       = Item['Meta_Property_OG_URL'];
      this.Meta_Property_OG_SiteName  = Item['Meta_Property_OG_SiteName'];
      this.Meta_Property_OG_Title     = Item['Meta_Property_OG_Title'];
      this.Meta_Property_OG_Description = Item['Meta_Property_OG_Description'];
      this.Meta_Property_OG_Author      = Item['Meta_Property_OG_Author'];
      this.Meta_Property_OG_Image       = Item['Meta_Property_OG_Image'];
      this.Meta_Property_Article_Author = Item['Meta_Property_Article_Author'];
      this.Meta_Property_Article_Publisher = Item['Meta_Property_Article_Publisher'];
      this.UpdateDetails = true

    }
  },
  mounted(){

      this.$http.post(`${this.$store.getters.GetProductionUrl}/courseseo/getlistpageseo`)
                .then(response => {

                    this.SEOList = response['data']['response']
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Failed To Fetch Data", Color: "red", Close: false});
                });
  }
};
</script>
<style>
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>